export const LEAVE_POST_TYPES_ANY = {
  PAID: 'Paid',
  UNPAID: 'Unpaid',
  AUTHORIZED_PAID_ABSENCE: 'AuthorizedPaidAbsence',
  MATERNITY_PATERNITY: 'MaternityPaternity',
  PARENTAL: 'Parental',
  SUPPLEMENTARY_BIRTH_LEAVE: 'SupplementaryBirthLeave',
  SCHOOL: 'School',
  FAMILY_EVENT: 'FamilyEvent',
  RECUPERATION: 'Recuperation',
  MEDICAL: 'Medical',
};

export const LEAVE_POST_TYPES_OWN = {
  PAID: 'Paid',
  UNPAID: 'Unpaid',
  RECUPERATION: 'Recuperation',
  SCHOOL: 'School',
};

/**
 * Types dont les dates sont imposées par un document externe (arrêt de travail,
 * attestation) et doivent donc pouvoir être saisies telles quelles, week-end inclus.
 */
export const LEAVE_POST_TYPES_ALLOWING_WEEKEND = [
  LEAVE_POST_TYPES_ANY.MEDICAL,
  LEAVE_POST_TYPES_ANY.MATERNITY_PATERNITY,
  LEAVE_POST_TYPES_ANY.PARENTAL,
  LEAVE_POST_TYPES_ANY.SUPPLEMENTARY_BIRTH_LEAVE,
];

const useLeavePost = () => {
  /**
   * Provides a list of types, each with a value and a label.
   *
   * @param {boolean} hasFullPermission
   *
   * @returns {Array<{value: string, label: string}>}
  */
  const getTypesOptions = (hasFullPermission) => (
    Object
      .values(hasFullPermission ? LEAVE_POST_TYPES_ANY : LEAVE_POST_TYPES_OWN)
      .map((type) => ({ value: type, label: `leavePost.types.${type}` }))
  );

  return {
    getTypesOptions,
  };
};

export default useLeavePost;
